import React, { useState } from "react";
import LoadableComponent from "../../shared/Loading/LoadableComponent";
import { Box, Checkbox, FormControlLabel, Grid, Paper } from "@material-ui/core";
import AccountForm from "./AccountForm";
import ButtonNav from "../../shared/NavBar/ButtonNav";
import useFinalizePage from "./hooks/useFinalizePage";
import BackButton from "../../shared/NavigationDrawer/BackButton";
import { useHistory } from "react-router";

const styleContainer = { padding: "2%", marginBottom: 100 };
const styleSum = { paddingTop: "2%" };

interface IProps {
  action: "pay" | "reservation";
  accDepositDefIds?: string;
}

const FinalizePage: React.FC<IProps> = ({ action, accDepositDefIds }: IProps) => {
  const history = useHistory();
  const [invoiceCompany, setInvoiceCompany] = useState(false);
  const [invoice, setInvoice] = useState(false);

  const { loading, getBasketTotal, account, check, setCheck, pay, reservation, userForm } = useFinalizePage(
    Boolean(invoiceCompany || invoice),
    accDepositDefIds
  );

  const setCreatInvoice = (isInvoice: boolean, isInvoiceCompany: boolean) => {
    setInvoice(isInvoice);
    setInvoiceCompany(isInvoiceCompany);
  };

  return (
    <React.Fragment>
      <LoadableComponent loading={loading}>
        <div style={styleContainer}>
          <Paper elevation={3}>
            <div style={{ paddingLeft: "2%" }}>
              {action === "pay" && <h2 style={styleSum}>Razem do zapłaty: {getBasketTotal().toFixed(2)} zł</h2>}
              <AccountForm {...userForm} accountData={account} isInvoice={invoice} isInvoiceCompany={invoiceCompany} />

              {action === "pay" && (
                <Grid container spacing={1}>
                  <Grid item xs={3}>
                    <ButtonNav
                      onClick={() => setCreatInvoice(false, false)}
                      buttonStyle={!invoice && !invoiceCompany ? "btn--primary" : "btn--outline"}
                      buttonSize={"btn--medium"}
                    >
                      {"Bez faktury"}
                    </ButtonNav>
                  </Grid>
                  <Grid item xs={3}>
                    <ButtonNav
                      onClick={() => setCreatInvoice(true, false)}
                      buttonStyle={invoice && !invoiceCompany ? "btn--primary" : "btn--outline"}
                      buttonSize={"btn--medium"}
                    >
                      {"Faktura na osobę"}
                    </ButtonNav>
                  </Grid>
                  <Grid item xs={3}>
                    <ButtonNav
                      onClick={() => setCreatInvoice(true, true)}
                      buttonStyle={invoiceCompany ? "btn--primary" : "btn--outline"}
                      buttonSize={"btn--medium"}
                    >
                      {"Faktura na firmę"}
                    </ButtonNav>
                  </Grid>
                </Grid>
              )}

              <FormControlLabel
                control={<Checkbox value={check} checked={check} onChange={() => setCheck(!check)} />}
                label={
                  <div>
                    Oświadczam, że zapoznałem się z{" "}
                    <a href={process.env.PUBLIC_URL + "/payURegulamin.pdf"} target={"_blank"}>
                      regulaminem
                    </a>{" "}
                    i zobowiązuje się do jego przestrzegania (*)
                  </div>
                }
              />
              <h6>Pola z (*) są wymagane</h6>
              <Box style={{ paddingBottom: 30, marginTop: 10, width: "30%" }}>
                <ButtonNav
                  onClick={() => (action === "pay" ? pay() : reservation())}
                  buttonStyle={"btn--green"}
                  buttonSize={"btn--large"}
                >
                  {action === "pay" ? "Zapłać" : "Rezerwuj"}
                </ButtonNav>
              </Box>
            </div>
          </Paper>
        </div>
      </LoadableComponent>

      <BackButton position={"relative"} onClick={() => history.goBack()} />
    </React.Fragment>
  );
};

export default FinalizePage;
